import React from 'react';
import Icon from '@/components/atoms/icon';
import { AiFillSignal } from 'react-icons/ai';
import { mapModifiers } from '@/utils/funtion';
import Link from 'next/link';
import { useDispatch, useSelector } from 'react-redux';
import { FaArrowAltCircleRight } from 'react-icons/fa';
import { setDetailUrl } from '@/stores/modules/detailUrl';
import { AreaVariant } from '../mapsPackage';

interface IProps {
  id: string;
  name: string;
  slug: string;
  type: string;
  activeItemId: string;
  onItemClick: (itemId: string) => void;
  isStructure: boolean;
  isObjectOneTime: boolean;
  hasMap?: boolean;
  isToday?: boolean;
  area?: AreaVariant;
}

const IndicatorCollapseItems: React.FC<IProps> = ({
  id,
  name,
  slug,
  type,
  activeItemId,
  onItemClick,
  isStructure,
  isObjectOneTime,
  hasMap = false,
  isToday,
  area,
}) => {
  const userData = useSelector((state: any) => state.userData);
  const dispatch = useDispatch();

  return (
    <div
      className={mapModifiers(
        'collapse-item',
        activeItemId === id ? 'active' : '',
      )}
      onClick={() => onItemClick(id)}
    >
      <div className="collapse-item_icon">
        <Icon
          component={
            activeItemId === id ? (
              <FaArrowAltCircleRight style={{ color: '#05d335' }} />
            ) : (
              <AiFillSignal />
            )
          }
        />
      </div>
      <p>
        {name}{' '}
        {!hasMap && type === 'local_indicator' && (
          <Link href="#"> [Chi tiết]</Link>
        )}
        {type !== 'local_indicator' && (
          <Link
            href={`/thong-tin-chi-tiet/${slug}/${id}?type=${type}&area=${area}&structure=${isStructure}&isObjectOneTime=${isObjectOneTime}`}
            
          >
            [Chi tiết]
          </Link>
        )}
      </p>
      {isToday && (
        <div className="collapse-item_new">
          <Icon iconName="newest" size="28x28" />
        </div>
      )}
    </div>
  );
};

export default IndicatorCollapseItems;
